import ImageUrl from "components/app/image-url/ImageUrl";
import { ShimmerCategoriesRender } from "components/app/shrimmer/Shrimmer";
import { Plus } from "lucide-react";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import UploadProductServicePotoGroup from "components/app/upload-profile/UploadProductServicePotoGroup";

const ProductItemGroup = ({
  containerRef,
  setHovered,
  hovered,
  setIsDialogOpenEditCategoies,
  setDefaultDataCategories,
  setEditItemCategories,
  setSelectedProductGroupCode,
  handleClickCategory,
  selectedProductGroupCode,
  itemGroups,
  loadingFetchDataCategoires,
  setId,
  setItemGroups,
}: any) => {
  return (
    <div
      ref={containerRef}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
    >
      <div className="relative w-full ">
        <div className="flex space-x-2 w-full">
          <HoverCardDetail
            title="Add New Group"
            description={
              <>
                <p className="mb-2 font-medium text-sm text-gray-800">
                  Create a new group to organize related products or services. Groups are useful for keeping your catalog structured and easy to manage.
                </p>
                <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                  <li>Use groups to categorize items by type, department, or usage.</li>
                  <li>Helps improve search, filtering, and bulk operations.</li>
                  <li>Essential for applying shared settings or pricing rules.</li>
                  <li>Groups appear in reports and dashboards for better insights.</li>
                </ul>
              </>
            }
          >
            <label
              onClick={() => {
                setIsDialogOpenEditCategoies(true);
                setDefaultDataCategories(true);
                setEditItemCategories(null);
                setSelectedProductGroupCode("All");
                handleClickCategory({
                  categoryName: "All",
                  groupId: "",
                });
              }}
              className="font-semibold rounded-md  lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 ld:p-3 p-2  flex items-center justify-center cursor-pointer text-md border "
            >
              <Plus className="font-semibold text-xl" />
            </label>
          </HoverCardDetail>

          <div
            onClick={() => {
              if (selectedProductGroupCode === "All") {
                setEditItemCategories("");
                if (itemGroups?.data?.length) {
                  setId(itemGroups.data[0].product_group_id);
                }
              }
              handleClickCategory({
                categoryName: "All",
                groupId: "",
              });
            }}
            className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
              selectedProductGroupCode === "All" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
            }`}
          >
            <span className="lg:text-sm md:text-sm text-[12px]">All</span>
          </div>
          {/* Product Categories */}
          <div className="space-x-2 flex">
            {loadingFetchDataCategoires ? (
              <>
                <ShimmerCategoriesRender />
              </>
            ) : (
              <>
                {itemGroups?.data?.map((group: any) => (
                  <div key={group.id} className="flex items-center">
                    <div
                      className={`w-[200px] border rounded-md cursor-pointer font-semibold 
                                ${
                                  selectedProductGroupCode === (group?.local_description ? group.local_description.toString() : "")
                                    ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                    : "dark:hover:bg-slate-900"
                                }`}
                      onClick={() => {
                        setEditItemCategories(group);
                        setDefaultDataCategories(false);
                        setId(group.product_group_id);
                        handleClickCategory({
                          categoryName: group?.local_description ?? "", // Ensure it's a string or fallback to ""
                          groupId: group?.product_group_id,
                        });
                      }}
                    >
                      <div className="flex group">
                        <div className="flex relative lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10">
                          {/* Image */}
                          <div className="lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10">
                            <ImageUrl className="rounded-md flex-shrink-0 object-cover w-full h-full" src={group?.thumbnail} alt="" />
                          </div>
                          <div className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
                            <UploadProductServicePotoGroup
                              itemGroups={group}
                              onUploadSuccess={({ res, name }) => {
                                setItemGroups((prevItemGroups: any) => {
                                  const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                                  const exists = updatedData.some((item: any) => item.id === res.id);
                                  if (!exists) {
                                    updatedData.push(res);
                                  }
                                  return {
                                    ...prevItemGroups,
                                    data: updatedData,
                                  };
                                });
                              }}
                            />
                          </div>
                          {/* Hover Overlay */}
                        </div>

                        <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden  flex items-center justify-center">
                          {group?.local_description ?? "No Description"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductItemGroup;
